export default __webpack_public_path__ + "static/media/tablet.c77d1e7f.png";